import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-ida-skeleton rounded-md bg-surface-3", className)}
      {...props} />
  );
}

export { Skeleton }
